import { refreshCartCount, refreshMiniCart, refreshUpsells } from './utils.js';

document.addEventListener('DOMContentLoaded', () => {
  const syncGroupedProductsInventory = () => {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const groupedProducts = Array.from(document.querySelectorAll('.c-grouped-products__product'));
        const cartItems = cart.items;
        const cartIds = cartItems.map((item) => item.variant_id);

        if (cartIds.length === 0) {
          groupedProducts.forEach((productEl) => {
            const originalStock = parseInt(productEl.dataset.originalInventory, 10);
            productEl.dataset.inventory = originalStock;
            productEl.classList.remove('c-grouped-products__product-out-of-stock');

            const qtyContainer = productEl.querySelector('.c-grouped-products__qty-container');
            if (qtyContainer) qtyContainer.style.display = '';

            const qtyInput = productEl.querySelector('.c-grouped-products__product-qty-input');
            if (qtyInput) {
              qtyInput.value = '0';
              productEl.dataset.quantity = '0';
            }
          });
        } else {
          cartItems.forEach((cartItem) => {
            const variantId = cartItem.variant_id;
            const purchasedQty = cartItem.quantity;
            const selector = `.c-grouped-products__product[data-product-id="${variantId}"]`;
            const productEl = document.querySelector(selector);
            if (!productEl) return;

            const originalStock = parseInt(productEl.dataset.originalInventory, 10);
            const leftoverInventory = Math.max(0, originalStock - purchasedQty);
            productEl.dataset.inventory = leftoverInventory;

            const backorderAllowed = productEl.dataset.backorderAllowed === 'true';
            const qtyContainer = productEl.querySelector('.c-grouped-products__qty-container');

            if (leftoverInventory <= 0 && !backorderAllowed) {
              productEl.classList.add('c-grouped-products__product-out-of-stock');
              if (qtyContainer) qtyContainer.style.display = 'none';
            } else if (qtyContainer) {
              qtyContainer.style.display = '';
            }
          });

          groupedProducts.forEach((productEl) => {
            const variantId = parseInt(productEl.dataset.productId, 10);
            const qtyContainer = productEl.querySelector('.c-grouped-products__qty-container');

            if (!cartIds.includes(variantId) && qtyContainer) {
              const originalStock = parseInt(productEl.dataset.originalInventory, 10);
              productEl.dataset.inventory = originalStock;
              productEl.classList.remove('c-grouped-products__product-out-of-stock');
              qtyContainer.style.display = '';
            }
          });
        }

        updateTotalPrice();
        refreshCartCount();
        refreshMiniCart();

        setTimeout(() => {
          refreshUpsells();
        }, 1000);
      })
      .catch((err) => console.error('Sync error:', err));
  };

  const cartDrawer = document.querySelector('cart-drawer');
  cartDrawer.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.c-product-card__add');
    if (addBtn) {
      syncGroupedProductsInventory();
    }

    const isQtyBtn = !!e.target.closest('.quantity__button');
    const isQtyInput = e.target.matches('.quantity__input');

    if (isQtyBtn || isQtyInput) {
      setTimeout(() => {
        syncGroupedProductsInventory();
      }, 1000);
    }

    const removeBtn = e.target.closest('cart-remove-button .c-button__remove-item');
    if (removeBtn) {
      setTimeout(() => {
        syncGroupedProductsInventory();
      }, 1000);
    }

    const addAllBtn = e.target.closest('.c-upsell-cart__add-all-btn');
    if (addAllBtn) {
      syncGroupedProductsInventory();
    }
  });

  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      cart.items.forEach((item) => {
        const sel = `.c-grouped-products__product[data-product-id="${item.variant_id}"]`;
        const productEl = document.querySelector(sel);
        if (!productEl) return;

        const origInv = parseInt(productEl.dataset.inventory, 10);
        const newInv = Math.max(0, origInv - item.quantity);
        productEl.dataset.inventory = newInv;

        const backorderAllowed = productEl.dataset.backorderAllowed === 'true';
        if (newInv <= 0 && !backorderAllowed) {
          productEl.classList.add('c-grouped-products__product-out-of-stock');
          const qtyCtr = productEl.querySelector('.c-grouped-products__qty-container');
          if (qtyCtr) qtyCtr.remove();
        }
      });

      updateTotalPrice();
    })
    .catch(console.error);

  const addToCart = () => {
    const isGroupedProduct = document.querySelector('.c-grouped-products') !== null;

    if (isGroupedProduct) {
      addGroupedProductsToCart();
    } else {
      addRegularProductToCart();
    }
  };

  const addGroupedProductsToCart = () => {
    const addToCartBtn = document.querySelector('.c-grouped-products__add-to-cart');
    const spinner = addToCartBtn?.querySelector('.loading__spinner');
    const btnText = addToCartBtn?.querySelector('span') || addToCartBtn;

    const products = document.querySelectorAll('.c-grouped-products__product');
    const itemsToAdd = [];
    let hasError = false;
    let totalQty = 0;

    products.forEach((productEl) => {
      const input = productEl.querySelector('.c-grouped-products__product-qty-input');
      if (!input) return;

      const quantity = parseInt(input.value, 10) || 0;
      const variantId = productEl.dataset.productId;
      const inventory = parseInt(productEl.dataset.inventory, 10);
      const backorderAllowed = productEl.dataset.backorderAllowed === 'true';
      const infoMsg = productEl.querySelector('.c-grouped-products__info-message');
      const errorContainer = productEl.querySelector('.c-grouped-products__product-qty-container');

      input.classList.remove('c-grouped-products__product-qty-input--error');
      if (infoMsg) infoMsg.style.display = 'none';
      productEl.querySelectorAll('.c-grouped-products__inventory-error').forEach((e) => e.remove());

      if (quantity > 0) {
        totalQty += quantity;

        if (quantity <= inventory || backorderAllowed) {
          itemsToAdd.push({ id: variantId, quantity });
        } else {
          const msg = document.createElement('div');
          msg.className = 'c-grouped-products__inventory-error';
          msg.style.marginTop = '2px';
          msg.style.color = '#d32f2f';
          msg.textContent = `Only ${inventory} in stock. Please reduce quantity.`;
          errorContainer.appendChild(msg);
          input.classList.add('c-grouped-products__product-qty-input--error');
          hasError = true;
        }
      }
    });

    if (hasError) return;
    if (totalQty === 0) {
      products.forEach((productEl) => {
        const input = productEl.querySelector('.c-grouped-products__product-qty-input');
        const msg = productEl.querySelector('.c-grouped-products__info-message');
        if (input) {
          input.classList.add('c-grouped-products__product-qty-input--error');
          if (msg) msg.style.display = 'block';
        }
      });
      const firstErrorInput = document.querySelector('.c-grouped-products__product-qty-input--error');
      firstErrorInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (addToCartBtn && totalQty > 0) {
      addToCartBtn.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
      if (btnText) btnText.style.opacity = '0.5';
    }

    const personalizationField = document.querySelector('[name="properties[Personalization]"]');
    const personalizationValue = personalizationField?.value?.trim();

    if (personalizationField) {
      // Personalization field is required - must not be empty
      if (personalizationValue === '') {
        personalizationField.classList.add('error');
        const errorMessage = personalizationField
          .closest('.product-form__personalization')
          ?.querySelector('.product-form__personalization-error');
        if (errorMessage) {
          errorMessage.textContent = 'This is a required field.';
          errorMessage.style.display = 'block';
        }

        personalizationField.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          if (btnText) btnText.style.opacity = '';
        }
        return; // Prevent adding to cart
      }

      // Check character limit
      const charLimit = parseInt(personalizationField.getAttribute('data-char-limit'));
      const currentLength = personalizationValue.length;

      if (currentLength > charLimit) {
        personalizationField.classList.add('error');
        const errorMessage = personalizationField
          .closest('.product-form__personalization')
          ?.querySelector('.product-form__personalization-error');
        if (errorMessage) {
          errorMessage.textContent = `Please enter no more than ${charLimit} characters.`;
          errorMessage.style.display = 'block';
        }

        personalizationField.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          if (btnText) btnText.style.opacity = '';
        }
        return; // Prevent adding to cart
      }
    }

    // Personalization field is required - always include it if field exists
    const itemsWithProperties = itemsToAdd.map((item) => {
      if (personalizationField && personalizationValue) {
        return {
          ...item,
          properties: {
            Personalization: personalizationValue,
          },
        };
      }
      return item;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsWithProperties }),
    })
      .then((r) => r.json())
      .then(async () => {
        itemsToAdd.forEach(({ id: variantId, quantity: quantityAdded }) => {
          const selector = `.c-grouped-products__product[data-product-id="${variantId}"]`;
          const productElement = document.querySelector(selector);
          if (!productElement) return;

          const currentInventory = parseInt(productElement.dataset.inventory, 10);
          const remainingInventory = currentInventory - quantityAdded;
          productElement.dataset.inventory = remainingInventory;

          const isBackorderAllowed = productElement.dataset.backorderAllowed === 'true';
          if (remainingInventory <= 0 && !isBackorderAllowed) {
            productElement.classList.add('c-grouped-products__product-out-of-stock');
            const qtyContainer = productElement.querySelector('.c-grouped-products__qty-container');
            if (qtyContainer) qtyContainer.style.display = 'none';
          }
        });

        document.querySelectorAll('.c-grouped-products__product-qty-input').forEach((i) => (i.value = 0));

        document.getElementById('cart-icon-bubble').click();
        updateTotalPrice();
      })
      .catch((err) => console.error('Cart error:', err))
      .finally(() => {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          if (btnText) btnText.style.opacity = '';

          refreshCartCount();
          refreshMiniCart();
          setTimeout(() => {
            refreshUpsells();
          }, 1000);
        }
      });
  };

  const addRegularProductToCart = () => {
    const addToCartBtn = document.querySelector('.c-grouped-products__add-to-cart');
    const spinner = addToCartBtn?.querySelector('.loading__spinner');
    const btnText = addToCartBtn?.querySelector('span') || addToCartBtn;

    const quantityInput = document.querySelector('quantity-input input[name="quantity"]');
    const variantIdInput = document.querySelector('input[name="id"]');

    if (!quantityInput || !variantIdInput) {
      console.error('Could not find quantity or variant ID inputs');
      return;
    }

    const quantity = parseInt(quantityInput.value, 10) || 1;
    const variantId = variantIdInput.value;

    if (quantity <= 0) {
      console.error('Invalid quantity');
      return;
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
      if (btnText) btnText.style.opacity = '0.5';
    }

    const personalizationField = document.querySelector('[name="properties[Personalization]"]');
    const personalizationValue = personalizationField?.value?.trim();

    if (personalizationField) {
      // Personalization field is required - must not be empty
      if (personalizationValue === '') {
        personalizationField.classList.add('error');
        const errorMessage = personalizationField
          .closest('.product-form__personalization')
          ?.querySelector('.product-form__personalization-error');
        if (errorMessage) {
          errorMessage.textContent = 'This is a required field.';
          errorMessage.style.display = 'block';
        }

        personalizationField.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          if (btnText) btnText.style.opacity = '';
        }
        return; // Prevent adding to cart
      }

      // Check character limit
      const charLimit = parseInt(personalizationField.getAttribute('data-char-limit'));
      const currentLength = personalizationValue.length;

      if (currentLength > charLimit) {
        personalizationField.classList.add('error');
        const errorMessage = personalizationField
          .closest('.product-form__personalization')
          ?.querySelector('.product-form__personalization-error');
        if (errorMessage) {
          errorMessage.textContent = `Please enter no more than ${charLimit} characters.`;
          errorMessage.style.display = 'block';
        }

        personalizationField.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          if (btnText) btnText.style.opacity = '';
        }
        return; // Prevent adding to cart
      }
    }

    const cartItem = {
      id: variantId,
      quantity: quantity,
    };

    // Personalization field is required - always include it if field exists
    if (personalizationField && personalizationValue) {
      cartItem.properties = {
        Personalization: personalizationValue,
      };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartItem),
    })
      .then((r) => r.json())
      .then(() => {
        document.getElementById('cart-icon-bubble').click();
      })
      .catch((err) => console.error('Cart error:', err))
      .finally(() => {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          if (btnText) btnText.style.opacity = '';
        }

        refreshCartCount();
        refreshMiniCart();
        setTimeout(() => {
          refreshUpsells();
        }, 1000);
      });
  };

  const formatMoney = (cents) => {
    const fmt = window.recentlyViewedMoneyFormat;
    const amount = (Number(cents) / 100).toFixed(2);
    return fmt.replace(/{{\s*amount\s*}}/, amount);
  };

  const updateTotalPrice = () => {
    const isGroupedProduct = document.querySelector('.c-grouped-products') !== null;
    if (!isGroupedProduct) return;

    let total = 0;
    document.querySelectorAll('.c-grouped-products__product').forEach((productEl) => {
      const price = parseFloat(productEl.dataset.price) || 0;
      const qty = parseInt(productEl.querySelector('.c-grouped-products__product-qty-input')?.value, 10) || 0;
      total += price * qty;
    });
    const priceEl = document.querySelector('.c-main-product__buy-fixed .price-item');
    if (!priceEl) return;
    if (total === 0) {
      priceEl.style.display = 'none';
    } else {
      priceEl.style.display = 'block';
      priceEl.textContent = formatMoney(total * 100);
    }
  };

  const isGroupedProduct = document.querySelector('.c-grouped-products') !== null;

  if (isGroupedProduct) {
    document.querySelectorAll('.c-grouped-products__product').forEach((productEl) => {
      const input = productEl.querySelector('.c-grouped-products__product-qty-input');
      const minusBtn = productEl.querySelector('.c-grouped-products__product-qty-btn--minus');
      const plusBtn = productEl.querySelector('.c-grouped-products__product-qty-btn--plus');
      const updateQuantity = (qty) => {
        qty = Math.max(0, qty);
        input.value = qty;
        productEl.dataset.quantity = qty;
        input.classList.remove('c-grouped-products__product-qty-input--error');
        const msg = productEl.querySelector('.c-grouped-products__info-message');
        if (msg) msg.style.display = 'none';
        updateTotalPrice();
      };
      minusBtn?.addEventListener('click', () => updateQuantity(parseInt(input.value, 10) - 1));
      plusBtn?.addEventListener('click', () => updateQuantity(parseInt(input.value, 10) + 1));
      input?.addEventListener('input', () => updateQuantity(parseInt(input.value, 10) || 0));
    });

    updateTotalPrice();
  }

  document.querySelectorAll('.c-grouped-products__add-to-cart').forEach((btn) => {
    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        addToCart();
      });
    }
  });

  updateTotalPrice();
});
